import { render, staticRenderFns } from "./FreeReturn.vue?vue&type=template&id=2706fe0f&scoped=true"
import script from "./FreeReturn.vue?vue&type=script&lang=js"
export * from "./FreeReturn.vue?vue&type=script&lang=js"
import style0 from "./FreeReturn.vue?vue&type=style&index=0&id=2706fe0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706fe0f",
  null
  
)

export default component.exports